import { Component, OnInit, ViewChild } from '@angular/core';

import { Tabs } from '@enums/tab.enum';
import { ActionName } from '@shared/enums/action-name';
import { TabOpenService } from '@services/tab-open.service';
import { CustomerService } from '@fs/services/customer';
import { JobSiteDetailModel } from '@fs/models/customer/job-site-detail-model';
import { CustomerEditComponent } from '@fs/components/customer/cust-edit/cust-edit.component';
import { PermissionPipe } from '@shared/pipes/permission';

@Component({
  selector: 'app-customer-search',
  templateUrl: './cust-search.component.html',
  styleUrls: ['./cust-search.component.scss'],
  providers: [CustomerService]
})
export class CustomerSearchLteComponent implements OnInit {

  //#region Input/Output
  @ViewChild("customerEdit") customerEdit: CustomerEditComponent;
  //#endregion

  //#region Variable Declarations
  public showDetail: boolean = false;
  public customerID: string = "";
  public jobsiteID: string = "";
  /**example: Jobsite */
  public type: string = "";
  public actionName = ActionName;
  public tabCounter: number;
  public detailData: any;
  public destroyTab: Boolean = false;
  public showCustomerEditModal: boolean = false;
  public showDetailLoader: boolean = false;
  public showCancelConfirmation: Boolean = false;
  /**flag used to add * in tab title if there are unsaved changes */
  public isUnsavedTriggered: boolean = false;
  //#endregion

  //#region Constructor
  constructor(
    private httpCustomerService: CustomerService,
    private permissionPipe: PermissionPipe,
    private tabopen: TabOpenService) {
    this.detailData = new JobSiteDetailModel();
    this.tabopen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        setTimeout(() => {
          this.customerEdit.SaveCustomerDetail()
        }, 100)
      }
    })
    this.tabopen.destroyModalEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter && response.event == "destroy") {
        this.showCustomerEditModal = false;
        this.tabopen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
        this.isUnsavedTriggered = false;
      }
      else if (response.tabCounter == this.tabCounter && response.event == "save") {
        setTimeout(() => {
          this.customerEdit.SaveCustomerDetail()
          this.tabopen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
          this.isUnsavedTriggered = false;
        }, 100)
      }
    })
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
  }

  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.customerEdit != undefined && this.customerEdit.customerEditForm != undefined && this.customerEdit.customerEditForm.dirty;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabopen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
      }
    }
  }
  //#endregion

  //#region Methods
  public PreviewDetail(data) {
    this.showDetail = data.show;
    this.customerID = data.customerID;
    this.jobsiteID = data.jobsiteID;
    this.type = data.type;
    this.GetPreviewData();
  }

  public OpenNewCustomerTab() {
    if (!this.permissionPipe.transform(ActionName.CreateCustomer))
      return;
    this.tabopen.OpenTab(
      {
        tabId: Tabs.FsLiteNewCustomer,
        params: {},
        tabTitle: 'New Customer'
      }
    )
  }

  public OpenEditCustomer(data: any) {
    this.detailData = data;
    this.showCustomerEditModal = true;
  }

  public CloseEditCustomer(data: any) {
    if (data != undefined) {
      if (typeof (data) == "boolean") {
        if (data)
          this.tabopen.DestroyTab(this.tabCounter, "modal")
        else
          this.showCustomerEditModal = false;
      }
      else {
        this.customerEdit = undefined;
        this.detailData = data;
        this.showCustomerEditModal = false;
        this.tabopen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
        this.isUnsavedTriggered = false;
      }
    }
    else
      this.showCustomerEditModal = false;
  }

  public DiscardChanges() {
    this.showCancelConfirmation = false;
    this.showCustomerEditModal = false;
  }

  public Saveandclose() {
    this.showCancelConfirmation = false;
    this.customerEdit.SaveCustomerDetail();
  }

  public Cancel() {
    this.showCancelConfirmation = false;
  }

  private GetPreviewData() {
    if (this.customerID != undefined && this.customerID != "") {
      this.showDetailLoader = true;
      if(this.type == 'JobSite' && this.jobsiteID != undefined && this.jobsiteID != "") {
        this.httpCustomerService.GetJobSiteDetail(this.customerID, this.jobsiteID, "Customer,TaxGroup,Contacts,PaymentTerm").subscribe(response => {
          if(response != null) {
            if(response.Customer!=null){
             this.detailData = response.Customer;
             response.Customer = null;  
            }          
            this.detailData.JobSites = [response];
          }
          // this.detailData = response;
          this.showDetailLoader = false;
        }, error => {
          this.showDetailLoader = false;
        });
      } else {
        this.httpCustomerService.GetBillingDetail(this.customerID, "Contacts,jobsites,PaymentTerm").subscribe(response => {
          this.detailData = response;
          this.showDetailLoader = false;
        }, error => {
          this.showDetailLoader = false;
        });
      }
    }
  }
  //#endregion
}